import { createContext, useContext, useCallback, useEffect } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

function resolve(dict, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), dict);
}

export function I18nProvider({ children }) {
  // Product decision 21.10.2026: the member app is German only (other locales stay in code, unused).
  const lang = "de";
  const setLang = useCallback(() => {}, []);

  // Keep <html lang> in sync so screen readers use the correct pronunciation.
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path, params) => {
      let value = resolve(translations[lang], path);
      if (value === undefined) value = resolve(translations.de, path);
      if (value === undefined) return path;
      if (params && typeof value === "string") {
        return value.replace(/\{(\w+)\}/g, (m, k) => (params[k] !== undefined ? params[k] : m));
      }
      return value;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
